import QRCode from 'qrcode';
import { FriendService } from '../../services/FriendService';
import { ApiClient } from '../../services/ApiClient';
import { AuthStore } from '../../core/store/authStore';
import { EventBus } from '../../core/events/EventBus';
import { ToastManager } from './Toast';
import { DuelService } from '../../services/DuelService';

export class FriendModal {
  private static overlayEl: HTMLElement | null = null;
  private static activeSubTab: 'list' | 'qr' | 'requests' = 'list';
  private static handleFriendsUpdated = () => {
    if (FriendModal.overlayEl) FriendModal.renderContent(FriendModal.overlayEl);
  };

  static async show(initialTab: 'list' | 'qr' | 'requests' = 'list'): Promise<void> {
    this.activeSubTab = initialTab;
    this.close();

    const overlay = document.createElement('div');
    overlay.className = 'ad-interstitial-overlay';
    overlay.style.zIndex = '100000';

    this.renderContent(overlay);
    document.body.appendChild(overlay);
    this.overlayEl = overlay;
    
    EventBus.on('friends:updated', this.handleFriendsUpdated);
  }

  private static async renderContent(overlay: HTMLElement): Promise<void> {
    const user = AuthStore.getUser();
    if (!user) {
      overlay.innerHTML = `
        <div class="glass-panel" style="width:90%;max-width:420px;padding:32px;border-radius:20px;background:#1e293b;border:1px solid #334155;display:flex;flex-direction:column;gap:20px;position:relative;align-items:center;text-align:center;">
          <button id="close-friend-modal" style="position:absolute;top:16px;right:20px;color:#94a3b8;font-size:1.4rem;">&times;</button>
          <div style="font-size:3rem;">🔒</div>
          <h2 style="font-size:1.4rem;font-weight:800;" class="gradient-text">Giriş Yapmalısınız</h2>
          <p style="color:#94a3b8;font-size:0.9rem;">Arkadaş sistemi ve QR kodu kullanmak için giriş yapın.</p>
        </div>`;
      overlay.querySelector('#close-friend-modal')?.addEventListener('click', () => this.close());
      return;
    }

    let friends: any[] = [];
    let requests: any[] = [];
    if (this.activeSubTab === 'list') {
      friends = await FriendService.getFriends();
    } else if (this.activeSubTab === 'requests') {
      requests = await FriendService.getRequests();
    }

    overlay.innerHTML = `
      <div class="glass-panel" style="width:90%;max-width:500px;padding:28px;border-radius:20px;display:flex;flex-direction:column;gap:20px;position:relative;background:#1e293b;border:1px solid #334155;">
        <button id="close-friend-modal" style="position:absolute;top:16px;right:20px;color:#94a3b8;font-size:1.4rem;">&times;</button>
        
        <div style="text-align:center;">
          <h2 style="font-size:1.5rem;font-weight:800;" class="gradient-text">👥 Arkadaş Sistemi &amp; QR Kod</h2>
        </div>

        <!-- Sub Tabs -->
        <div style="display:flex;gap:10px;background:rgba(15,23,42,0.6);padding:4px;border-radius:10px;">
          <button id="friend-tab-list" style="flex:1;padding:8px;border-radius:8px;font-weight:700;font-size:0.85rem;${this.activeSubTab === 'list' ? 'background:#6366f1;color:#fff;' : 'color:#94a3b8;'}">👥 Arkadaş Listesi</button>
          <button id="friend-tab-requests" style="flex:1;padding:8px;border-radius:8px;font-weight:700;font-size:0.85rem;${this.activeSubTab === 'requests' ? 'background:#6366f1;color:#fff;' : 'color:#94a3b8;'}">📬 İstekler</button>
          <button id="friend-tab-qr" style="flex:1;padding:8px;border-radius:8px;font-weight:700;font-size:0.85rem;${this.activeSubTab === 'qr' ? 'background:#6366f1;color:#fff;' : 'color:#94a3b8;'}">📱 QR Kodum</button>
        </div>

        ${this.activeSubTab === 'list' ? `
          <!-- Tag ile Arama Formu -->
          <div id="add-friend-form" style="display:flex;gap:10px;">
            <input type="text" id="friend-tag-input" placeholder="Player Tag: #4892" style="flex:1;padding:10px 14px;background:#0f172a;border:1px solid #334155;border-radius:8px;color:#fff;outline:none;font-size:0.9rem;">
            <button id="search-friend-btn" type="button" style="padding:10px 18px;background:linear-gradient(135deg,#6366f1,#a855f7);color:#fff;border-radius:8px;font-weight:700;font-size:0.88rem;">➕ Ekle</button>
          </div>
          <div id="friend-search-result" style="display:none;padding:12px 16px;background:rgba(15,23,42,0.8);border:1px solid #334155;border-radius:10px;"></div>

          <!-- Arkadaş Listesi -->
          <div style="display:flex;flex-direction:column;gap:10px;max-height:240px;overflow-y:auto;">
            ${friends.length > 0
              ? friends.map(f => `
              <div style="display:flex;justify-content:space-between;align-items:center;padding:10px 14px;background:rgba(15,23,42,0.6);border:1px solid #334155;border-radius:10px;">
                <div style="display:flex;align-items:center;gap:10px;">
                  <span style="width:10px;height:10px;border-radius:50%;background:${f.status === 'online' ? '#22c55e' : f.status === 'in_game' ? '#f59e0b' : '#64748b'};display:inline-block;box-shadow:0 0 8px ${f.status === 'online' ? '#22c55e' : f.status === 'in_game' ? '#f59e0b' : 'transparent'};"></span>
                  <div>
                    <div style="font-size:0.92rem;font-weight:700;color:#f8fafc;">${f.username} <span style="color:#818cf8;font-size:0.78rem;">${f.tag || '#???'}</span></div>
                    <div style="font-size:0.75rem;color:#94a3b8;">${f.status === 'in_game' ? `🎮 Oynuyor: ${f.bestGame || 'Oyun'}` : f.status === 'online' ? '🟢 Lobide' : '⚫ Çevrimdışı'}</div>
                  </div>
                </div>
                <div style="display:flex;align-items:center;gap:12px;">
                  ${(f.status === 'online' || f.status === 'in_game') ? `
                    <button data-duel-friend="${f.id}" style="padding:4px 8px;background:linear-gradient(135deg,#f43f5e,#e11d48);color:#fff;border-radius:6px;font-weight:700;font-size:0.75rem;border:none;cursor:pointer;">
                      ⚔️ Düello
                    </button>
                  ` : ''}
                  <button data-remove-friend="${f.id}" style="color:#ef4444;font-size:0.8rem;padding:4px;" title="Arkadaşlıktan Çıkar">✕</button>
                </div>
              </div>`).join('')
              : `<div style="text-align:center;color:#64748b;padding:20px;">Henüz arkadaş eklemediniz.</div>`
            }
          </div>
        ` : this.activeSubTab === 'requests' ? `
          <!-- Gelen İstekler -->
          <div style="display:flex;flex-direction:column;gap:10px;max-height:240px;overflow-y:auto;">
            ${requests.length > 0
              ? requests.map(r => `
              <div style="display:flex;justify-content:space-between;align-items:center;padding:10px 14px;background:rgba(15,23,42,0.6);border:1px solid #334155;border-radius:10px;">
                <div style="display:flex;align-items:center;gap:10px;">
                  <div>
                    <div style="font-size:0.92rem;font-weight:700;color:#f8fafc;">${r.username} <span style="color:#818cf8;font-size:0.78rem;">${r.player_tag || '#???'}</span></div>
                  </div>
                </div>
                <div style="display:flex;align-items:center;gap:8px;">
                  <button data-accept-friend="${r.id}" style="padding:6px 10px;background:linear-gradient(135deg,#22c55e,#16a34a);color:#fff;border-radius:6px;font-weight:700;font-size:0.8rem;border:none;cursor:pointer;">
                    Kabul Et
                  </button>
                  <button data-reject-friend="${r.id}" style="padding:6px 10px;background:rgba(239, 68, 68, 0.2);color:#ef4444;border-radius:6px;font-weight:700;font-size:0.8rem;border:1px solid #ef4444;cursor:pointer;">
                    Reddet
                  </button>
                </div>
              </div>`).join('')
              : `<div style="text-align:center;color:#64748b;padding:20px;">Bekleyen istek yok.</div>`
            }
          </div>
        ` : `
          <!-- QR Kod Görünümü -->
          <div style="display:flex;flex-direction:column;align-items:center;gap:16px;padding:10px 0;">
            <div style="background:#ffffff;padding:16px;border-radius:16px;box-shadow:0 10px 30px rgba(0,0,0,0.5);text-align:center;">
              <canvas id="qr-canvas" style="display:block;border-radius:8px;"></canvas>
              <div style="color:#0f172a;font-weight:800;font-size:1rem;margin-top:8px;">${user.username} <span style="color:#6366f1;">${user.tag}</span></div>
            </div>
            <p style="color:#94a3b8;font-size:0.85rem;text-align:center;max-width:320px;">
              Arkadaşınız bu QR kodu kamerası ile tarayarak <strong>Player Tag'inizi</strong> otomatik alır ve sizi ekler.
            </p>
            <button id="download-qr-btn" style="padding:10px 20px;background:linear-gradient(135deg,#6366f1,#a855f7);color:#fff;border-radius:10px;font-weight:700;font-size:0.88rem;">
              ⬇️ QR Kodu İndir
            </button>
          </div>
        `}
      </div>`;

    // ─── Events ───────────────────────────────────────────────────────────────
    overlay.querySelector('#close-friend-modal')?.addEventListener('click', () => this.close());
    overlay.querySelector('#friend-tab-list')?.addEventListener('click', () => {
      this.activeSubTab = 'list';
      this.renderContent(overlay);
    });
    overlay.querySelector('#friend-tab-requests')?.addEventListener('click', () => {
      this.activeSubTab = 'requests';
      this.renderContent(overlay);
    });
    overlay.querySelector('#friend-tab-qr')?.addEventListener('click', () => {
      this.activeSubTab = 'qr';
      this.renderContent(overlay);
    });

    // ─── Friend search by tag ─────────────────────────────────────────────────
    const searchBtn = overlay.querySelector('#search-friend-btn');
    if (searchBtn) {
      searchBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        const input  = overlay.querySelector('#friend-tag-input') as HTMLInputElement;
      const tag    = input.value.trim();
      const result = overlay.querySelector('#friend-search-result') as HTMLElement;

      if (!tag.startsWith('#')) {
        ToastManager.show('Player Tag # ile başlamalıdır (ör: #4892)', 'error');
        return;
      }

      result.style.display = 'block';
      result.innerHTML = '<span style="color:#94a3b8;">Aranıyor...</span>';

      const { data, error } = await ApiClient.searchByTag(tag);

      if (error || !data) {
        result.innerHTML = `<span style="color:#ef4444;">❌ ${tag} tag'li oyuncu bulunamadı.</span>`;
        return;
      }

      if (data.id === user.id) {
        result.innerHTML = `<span style="color:#f59e0b;">⚠️ Kendinizi ekleyemezsiniz.</span>`;
        return;
      }

      result.innerHTML = `
        <div style="display:flex;justify-content:space-between;align-items:center;">
          <div>
            <div style="font-weight:700;color:#f8fafc;">${data.username} <span style="color:#818cf8;">${data.player_tag}</span></div>
            <div style="font-size:0.75rem;color:#94a3b8;">Oyuncu bulundu</div>
          </div>
          <button id="confirm-add-friend" style="padding:8px 14px;background:linear-gradient(135deg,#22c55e,#16a34a);color:#fff;border-radius:8px;font-weight:700;font-size:0.82rem;">✓ Ekle</button>
        </div>`;

      result.querySelector('#confirm-add-friend')?.addEventListener('click', async () => {
        await FriendService.addFriend(`${data.username}${data.player_tag}`);
        this.activeSubTab = 'list';
        this.renderContent(overlay);
      });
    });
  }

    // ─── Accept / Reject Requests ─────────────────────────────────────────────
    if (this.activeSubTab === 'requests') {
      overlay.querySelectorAll('button[data-accept-friend]').forEach(btn => {
        btn.addEventListener('click', async (e) => {
          const friendId = (e.currentTarget as HTMLButtonElement).dataset.acceptFriend!;
          await FriendService.acceptRequest(friendId);
          this.renderContent(overlay);
        });
      });

      overlay.querySelectorAll('button[data-reject-friend]').forEach(btn => {
        btn.addEventListener('click', async (e) => {
          const friendId = (e.currentTarget as HTMLButtonElement).dataset.rejectFriend!;
          await FriendService.rejectRequest(friendId);
          this.renderContent(overlay);
        });
      });
    }

    // ─── Generate real QR code ────────────────────────────────────────────────
    if (this.activeSubTab === 'qr') {
      const canvas = overlay.querySelector('#qr-canvas') as HTMLCanvasElement | null;
      if (canvas) {
        try {
          // QR data encodes the player's unique tag so anyone who scans it
          // can find them by tag in the friend search
          const qrData = `arcade-portal://add-friend?tag=${encodeURIComponent(user.tag)}&user=${encodeURIComponent(user.username)}`;
          await QRCode.toCanvas(canvas, qrData, {
            width: 180,
            color: { dark: '#000000', light: '#ffffff' },
            errorCorrectionLevel: 'H',
          });

          // Download button
          overlay.querySelector('#download-qr-btn')?.addEventListener('click', () => {
            const link = document.createElement('a');
            link.download = `arcade-qr-${user.tag.replace('#', '')}.png`;
            link.href = canvas.toDataURL('image/png');
            link.click();
          });
        } catch {
          canvas.parentElement!.innerHTML = '<div style="color:#ef4444;padding:20px;">QR oluşturulamadı.</div>';
        }
      }
    }

    // ─── Remove friend buttons ────────────────────────────────────────────────
    overlay.querySelectorAll('[data-remove-friend]').forEach((btn) => {
      btn.addEventListener('click', async (e) => {
        const id = (e.currentTarget as HTMLElement).getAttribute('data-remove-friend');
        if (id) {
          await FriendService.removeFriend(id);
          this.renderContent(overlay);
        }
      });
    });

    // ─── Duel buttons ─────────────────────────────────────────────────────────
    overlay.querySelectorAll('[data-duel-friend]').forEach((btn) => {
      btn.addEventListener('click', async (e) => {
        const id = (e.currentTarget as HTMLElement).getAttribute('data-duel-friend');
        if (id) {
          const friend = friends.find(f => f.id === id);
          if (friend && friend.bestGame) {
            await DuelService.sendInvite(id, friend.bestGame);
          } else {
            ToastManager.show('Kullanıcının henüz bir oyun kaydı yok.', 'warning');
          }
        }
      });
    });
  }

  static close(): void {
    if (this.overlayEl) {
      this.overlayEl.remove();
      this.overlayEl = null;
    }
    EventBus.off('friends:updated', this.handleFriendsUpdated);
  }
}
